import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useNavigatorStore = defineStore('navigator', () => {
  const isMobile = ref(null)
  function setIsMobile() {
    isMobile.value = window.innerWidth < 992
  }

  return { isMobile, setIsMobile }
})